import { SerializableObject } from './serializable-object';
import { MobizPermission } from './mobiz-permission.do';
import { isNil } from 'lodash';

export enum AuthorizationType {
  Granted = 'Granted',
  Denied = 'Denied',
}

export class MobizPermissionAssignment extends SerializableObject {
  public permission: MobizPermission;
  public authorization: AuthorizationType;
  public weight: number;

  protected coercePropertyType(property: string, value: any) {
    let returnValue = null;
    if (isNil(value)) {
      return returnValue;
    }

    switch (property) {
      case 'permission':
        returnValue = new MobizPermission(value);
        break;

      default:
        returnValue = value;
    }

    return returnValue;
  }

  public isGranted(): boolean {
    return this.authorization === AuthorizationType.Granted;
  }

}
